import { Typography } from '@mui/material'
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TableTags } from 'src/components/tags/TableTags'
import { LinkableSubcontractor } from 'src/interfaces/subcontractor'
import { Tag } from 'src/interfaces/tag'
import { colors } from 'src/theme'
import { gridFormatters, gridValueGetters } from 'src/utils/grid'

export const assignContractorsColumns: Array<GridColDef> = [
  {
    field: 'externalId',
    headerName: 'ID',
    flex: 1,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {params.row.id}
      </Typography>
    ),
  },
  {
    field: 'firstName',
    headerName: 'Name',
    flex: 2,
    sortable: true,
    renderCell: (params) => (
      <Typography variant="body2" color={colors.SHADES_GREY_400}>
        {`${params.row.firstName} ${params.row.lastName}`}
      </Typography>
    ),
  },
  {
    field: 'email',
    headerName: 'Email',
    flex: 2,
    sortable: true,
  },
  {
    field: 'phone',
    headerName: 'Phone number',
    flex: 2,
    sortable: true,
  },
  {
    field: 'tags',
    headerName: 'Tag(s)',
    flex: 3,
    sortable: false,
    sortComparator: (v1: Tag[], v2: Tag[]) => {
      return v1.length - v2.length
    },
    renderCell: (params: GridRenderCellParams<LinkableSubcontractor>) =>
      params.row?.tags.length ? <TableTags tags={params.row?.tags || []} /> : <span>-</span>,
  },
  {
    field: 'onboardedAt',
    headerName: 'Date Onboarded',
    flex: 2,
    sortable: true,
    valueGetter: gridValueGetters.parseDate,
    valueFormatter: gridFormatters.formatShortDate,
  },
]

export const assignContractorsPageSizeOptions = [100, 250, 500, 1000]
